<script>
  import 'codemirror/lib/codemirror.css'
  import '@toast-ui/editor/dist/toastui-editor.css'

  import { createEventDispatcher, getContext } from 'svelte'
  import {linkFormat} from '../../utils'
  const dispatch = createEventDispatcher()

  import { uploadImages } from '../../../services/strapiRestService'
  import WrongImageFormatModal from "../../components/wrong-image-format-modal/WrongImageFormatModal.svelte";

  let editor
  export let initialValue = ''

  const { open } = getContext("simple-modal");

  const initEditor = async (node) => {
    const Editor = (await import('@toast-ui/editor')).default
    let options = {
      initialEditType: 'wysiwyg',
      height: '300px',
      initialValue: initialValue,
      hideModeSwitch: true,
      el: node,
      linkAttribute: {
        target: "_blank",
      },
      toolbarItems: [
        'heading',
        'bold',
        'italic',
        'strike',
        'divider',
        'hr',
        'quote',
        'divider',
        'ul',
        'ol',
        'task',
        'indent',
        'outdent',
        'divider',
        'table',
        'image',
        'link'
      ],
      hooks: {
        addImageBlobHook: async function (blob, callback) {
            if(blob.type != "image/png" && blob.type != "image/jpeg") {
                return open(
                    WrongImageFormatModal,
                );
            }
            dispatch('upload', true);
            uploadImages(blob).then((res) => {
                  callback(`${ res[0].url}`, '');
                  dispatch('upload', false);
            });

            
        },
      },
    }
    editor = new Editor(options)

    editor.on('change', () => {
      dispatch('change', {
        value: linkFormat(editor.getMarkdown()),
        editor: editor,
      })
    })
  
    return {
      destroy() {
        editor.remove()
      },
    }
  }
</script>

<div use:initEditor />
